<template>
  <b-overlay :show="isLoading">
    <b-row>
      <b-col cols="12">
        <b-card v-if="salariesList">
          <h1 class="mb-3">
            لیست درآمد استاد {{ computedMasterName }} ({{
              computedMasterMobile
            }})
          </h1>
          <div class="my-2">
            <!-- Table Top Start -->
            <b-row>
              <!-- Search -->
              <b-col cols="12">
                <div
                  class="d-flex flex-column flex-wrap flex-md-row align-items-md-center"
                >
                  <b-form-group
                    label="جستجو بر اساس نام زبان آموز"
                    label-for="studentUserFullname"
                    class="mx-md-1"
                  >
                    <b-form-input
                      id="studentUserFullname"
                      v-model="masterSalariesFilters.studentUserFullname"
                      type="text"
                      class="d-inline-block"
                      placeholder="علی..."
                      @keydown.enter="setPageNumberAndGetMasterSalaries"
                    />
                  </b-form-group>
                  <b-form-group
                    label="بازه تاریخ درآمد استاد"
                    label-for="fromDate"
                    class="ml-md-1"
                  >
                    <b-input-group>
                      <template #append>
                        <b-input-group-text
                          class="cursor-pointer"
                          @click="clearDateRange"
                        >
                          <strong class="text-danger">
                            <feather-icon icon="Trash2Icon" size="16" />
                          </strong>
                        </b-input-group-text>
                      </template>
                      <b-form-input
                        :value="computedRangeDateText"
                        class="fromDate"
                        id="fromDate"
                        placeholder="بازه‌ی تاریخ را انتخاب کنید"
                      ></b-form-input>
                    </b-input-group>
                    <date-picker
                      range
                      v-model="dateRange"
                      :clearable="true"
                      class="absolute"
                      customInput=".fromDate"
                      display-format="jYYYY/jMM/jDD"
                      input-format="YYYY/MM/DD"
                      format="YYYY-MM-DD"
                    ></date-picker>
                  </b-form-group>

                  <b-form-group
                    label="جستجو بر اساس تعداد جلسات برگزار شده"
                    label-for="schedualCount"
                    class="mx-md-1"
                  >
                    <b-form-input
                      id="schedualCount"
                      v-model.number="masterSalariesFilters.schedualCount"
                      type="number"
                      class="d-inline-block"
                      placeholder="جستجوی تعداد جلسات..."
                      @keydown.enter="setPageNumberAndGetMasterSalaries"
                    />
                  </b-form-group>
                  <price-category-picker
                    :defaultPriceCategoryIds="
                      masterSalariesFilters.priceCategoryId
                    "
                    @getPriceCategory="setPriceCategory"
                    class="w-24 filters-width mr-md-2"
                  ></price-category-picker>
                  <b-button
                    variant="primary"
                    @click="setPageNumberAndGetMasterSalaries"
                  >
                    اعمال
                  </b-button>
                </div>
              </b-col>
              <b-col cols="12">
                <p>
                  مجموع درآمد استاد:
                  <span class="text-primary">
                    {{ Intl.NumberFormat("en-US").format(masterSumPrice) }}
                  </span>
                  تومان
                </p>
                <p>
                  جمع دقایق تدریس شده:
                  <span class="text-primary">
                    {{ Intl.NumberFormat("en-US").format(masterSumMinute) }}
                  </span>
                  دقیقه
                </p>
              </b-col>
            </b-row>
            <!-- Table Top End -->
            <b-row class="mb-2">
              <b-col cols="12">
                <b-table
                  ref="refUserListTable"
                  class="position-relative"
                  :items="salariesList"
                  responsive
                  :fields="myTableColumns"
                  primary-key="id"
                  show-empty
                  bordered
                  striped
                  empty-text="موردی موجود نیست!"
                >
                  <template #cell(studentUserFullname)="data">
                    <b-link :to="`/users/${data.item.studentUserId}`">
                      {{ data.item.studentUserFullname }}
                    </b-link>
                  </template>
                  <template #cell(schedualCount)="data">
                    <span style="white-space: nowrap">
                      {{ data.item.schedualCount }}
                      جلسه
                    </span>
                  </template>
                  <template #cell(basePrice)="data">
                    <span style="white-space: nowrap">
                      {{
                        Intl.NumberFormat("en-US").format(data.item.basePrice)
                      }}
                      تومان
                    </span>
                  </template>
                  <template #cell(priceCategoryTitle)="data">
                    <span style="white-space: nowrap">
                      {{ data.item.priceCategoryTitle }}
                    </span>
                  </template>
                  <template #cell(callPrice)="data">
                    <span style="white-space: nowrap">
                      <template v-if="data.item.callPrice">
                        {{
                          Intl.NumberFormat("en-US").format(data.item.callPrice)
                        }}
                        تومان
                      </template>
                      <template v-else> ندارد </template>
                    </span>
                  </template>
                  <template #cell(sumPrice)="data">
                    <span style="white-space: nowrap">
                      {{
                        Intl.NumberFormat("en-US").format(data.item.sumPrice)
                      }}
                      تومان
                    </span>
                  </template>
                  <template #cell(sumPlusCall)="data">
                    <span style="white-space: nowrap">
                      {{
                        Intl.NumberFormat("en-US").format(
                          data.item.sumPrice + data.item.callPrice
                        )
                      }}
                      تومان
                    </span>
                  </template>
                  <template #cell(actions)="data">
                    <b-link
                      :to="generateRouteObj($route.params.id, data.item.id)"
                    >
                      <feather-icon
                        class="text-primary"
                        icon="ExternalLinkIcon"
                        size="20"
                      />
                    </b-link>
                  </template>
                </b-table>
              </b-col>
              <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-end py-2"
              >
                <b-pagination
                  v-model="masterSalariesFilters.pageNumber"
                  :total-rows="totalCount"
                  :per-page="masterSalariesFilters.count"
                  first-number
                  last-number
                  class="mb-0 mt-1 mt-sm-0"
                  prev-class="prev-item"
                  next-class="next-item"
                >
                  <template #prev-text>
                    <feather-icon
                      style="transform: rotate(180deg)"
                      icon="ChevronLeftIcon"
                      size="18"
                    />
                  </template>
                  <template #next-text>
                    <feather-icon icon="ChevronRightIcon" size="18" />
                  </template>
                </b-pagination>
              </b-col>
            </b-row>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>
export default {
  watch: {
    pageNumber: {
      handler(val) {
        this.getAllMasterSalaries();
      },
    },
  },
  mounted() {
    if (
      this.$route.query &&
      this.$route.query.fromDate &&
      this.$route.query.toDate
    ) {
      this.masterSalariesFilters.fromDate = new Date(
        +this.$route.query.fromDate
      )
        .toISOString()
        .split("T")[0];
      this.masterSalariesFilters.toDate = new Date(+this.$route.query.toDate)
        .toISOString()
        .split("T")[0];
      this.dateRange = [
        new Date(+this.$route.query.fromDate).toISOString().split("T")[0],
        new Date(+this.$route.query.toDate).toISOString().split("T")[0],
      ];
    }
    Object.keys(this.masterSalariesFilters).forEach((key) => {
      if (this.$route.query[key]) {
        this.masterSalariesFilters[key] = this.$route.query[key];
      }
    });
    this.getAllMasterSalaries();
  },
  data() {
    return {
      isLoading: false,
      sumSalary: null,
      salariesList: null,
      totalCount: null,
      dateRange: null,
      masterSalariesFilters: {
        studentUserFullname: null,
        fromDate: null,
        toDate: null,
        masterUserId: null,
        userfullname: null,
        userMobile: null,
        userNationalId: null,
        schedualCount: null,
        sumPrice: null,
        pageNumber: 1,
        count: 10,
        priceCategoryId: null,
      },
      masterSumPrice: null,
      masterSumMinute: null,
      myTableColumns: [
        {
          key: "id",
          label: "شناسه",
        },
        {
          key: "studentUserFullname",
          label: "نام زبان آموز",
        },
        {
          key: "schedualCount",
          label: "تعداد جلسات برگزار شده",
        },
        {
          key: "priceCategoryTitle",
          label: "گروه بندی",
        },
        {
          key: "sumMinute",
          label: "جمع دقایق",
        },
        {
          key: "basePrice",
          label: "قیمت پایه هر جلسه",
        },
        {
          key: "callPrice",
          label: "هزینه تماس",
        },
        {
          key: "sumPrice",
          label: "میزان درآمد",
        },
        {
          key: "sumPlusCall",
          label: "جمع درآمد و تماس",
        },
        {
          key: "actions",
          label: "جزئیات",
        },
      ],
    };
  },
  methods: {
    generateRouteObj(masterUserId, sessionId) {
      let requiredQueryKeys = [
        "fromDate",
        "toDate",
        "priceCategoryId",
        "studentUserId",
        "studentUserFullname",
        "studentUserMobile",
      ];
      let queries = {};
      requiredQueryKeys.forEach((key) => {
        if (this.masterSalariesFilters[key]) {
          if (this.masterSalariesFilters[key].constructor == Date) {
            queries[key] = Date.parse(
              new Date(this.masterSalariesFilters[key])
            );
          } else {
            queries[key] = this.masterSalariesFilters[key];
          }
        }
      });
      return {
        path: `/users/masters-salary/${masterUserId}/${sessionId}`,
        query: queries,
      };
    },
    setPriceCategory(priceCategoryId) {
      this.masterSalariesFilters.priceCategoryId = priceCategoryId;
    },
    clearDateRange() {
      this.dateRange = null;
      this.masterSalariesFilters.fromDate = null;
      this.masterSalariesFilters.toDate = null;
    },
    calculateDates() {
      if (this.dateRange && this.dateRange.length > 0) {
        this.masterSalariesFilters.fromDate = new Date(this.dateRange?.[0]);
        this.masterSalariesFilters.toDate = new Date(this.dateRange?.[1]);
      }
    },
    async getAllMasterSalaries() {
      try {
        this.isLoading = true;
        let _this = this;
        let getMastersSalaryList = new GetMastersSalaryList(_this);
        getMastersSalaryList.setRequestParamDataObj(
          _this.handleMasterSalariesFilters()
        );
        await getMastersSalaryList.fetch((res) => {
          _this.salariesList = res.data;
          _this.totalCount = res.total;
          _this.masterSumPrice = res.sumPrice;
          _this.masterSumMinute = res.sumMinute;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    setPageNumberAndGetMasterSalaries() {
      this.masterSalariesFilters.pageNumber = 1;
      this.calculateDates();
      let requiredQueryKeys = [
        "fromDate",
        "toDate",
        "priceCategoryId",
        "studentUserId",
        "studentUserFullname",
        "studentUserMobile",
      ];
      let queries = {};
      requiredQueryKeys.forEach((key) => {
        if (this.masterSalariesFilters[key]) {
          if (this.masterSalariesFilters[key].constructor == Date) {
            queries[key] = Date.parse(
              new Date(this.masterSalariesFilters[key])
            );
          } else {
            queries[key] = this.masterSalariesFilters[key];
          }
        }
      });
      this.$router.push({
        path: this.$route.path,
        query: queries,
      });
      this.getAllMasterSalaries();
    },
    handleMasterSalariesFilters() {
      this.calculateDates();
      let payload = {
        ...this.masterSalariesFilters,
      };
      payload["masterUserId"] = this.$route.params.id;
      return payload;
    },
  },
  computed: {
    pageNumber() {
      return this.masterSalariesFilters.pageNumber;
    },
    computedRangeDateText() {
      if (this.dateRange && this.dateRange.length > 1) {
        return `${new Date(this.dateRange[0]).toLocaleDateString(
          "fa-IR"
        )} ~ ${new Date(this.dateRange[1]).toLocaleDateString("fa-IR")}`;
      }
      return null;
    },
    computedMasterName() {
      if (this.salariesList && this.salariesList.length > 0) {
        return this.salariesList[0].userfullname;
      }
      return null;
    },
    computedMasterMobile() {
      if (this.salariesList && this.salariesList.length > 0) {
        return this.salariesList[0].userMobile;
      }
      return null;
    },
  },
  components: {
    BCard,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BModal,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BOverlay,
    BInputGroup,
    BInputGroupText,
    PriceCategoryPicker,
  },
};
import {
  BCard,
  BRow,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BModal,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BOverlay,
  BInputGroup,
  BInputGroupText,
} from "bootstrap-vue";
import { GetMastersSalaryList } from "@/libs/Api/MasterUserPayment";
import PriceCategoryPicker from "@/views/apps/PriceCategory/PriceCategoryPicker.vue";
</script>
